import { useEffect, useState } from "react";
import menuService from "../services/menuService";
import { GeneralService } from "../services/GeneralService";
import { notify } from "../components/Customs/NotifyProvider";

export default function useMenu() {

  const [menus, setMenus] = useState([]);
  const [fC, setFC] = useState([]);
  const [loading, setLoading] = useState(false);
  const [zone, setZone] = useState([]);
  const [cat, setCat] = useState([]);
  
  const fetchMenus = async () => {
    setLoading(true);
    const data = await GeneralService.get("menu_items");

    console.log("data", data);

    setMenus(data?.data);
    setLoading(false);
  };

  const fetchZone = async () => {
    const data = await GeneralService.get("zones");

    console.log("data", data);

    setZone(data?.data);
  };
  const fetchCat = async () => {
    const data = await GeneralService.get("categories");

    console.log("data", data);

    setCat(data?.data);
  };

  const fetchFC = async () => {
    setLoading(true);
    const data = await GeneralService.get("menu_items");

    console.log("data", data);

    setFC(data?.data);
    setLoading(false);
  };

  const createMenu = async (table, payload) => {
    const data = await GeneralService.create(table, payload);

    if (data.status) {
      notify.success(data?.message)
      fetchMenus();
    } else {
      notify.error(data?.message)
      fetchMenus();
    }

  };

  const createFC = async (table, payload) => {
    const data = await GeneralService.create(table, payload);

    if (data.status) {
      notify.success(data?.message)
      fetchFC();
    } else {
      notify.error(data?.message)
      fetchFC();
    }

  };

  const updateMenu = async (table, id, payload) => {
    const data = await GeneralService.update(table, id, payload);
     if (data.status) {
      notify.success(data?.message)
      fetchMenus();
    } else {
      notify.error(data?.message)
      fetchMenus();
    }
  };

  const deleteMenu = async (table, id) => {
  try {
    const data = await GeneralService.delete(table, id);

    if (data?.status) {
      notify.success(data?.message || "Deleted successfully");
    } else {
      notify.error(
        data?.message?.sqlMessage ||
        data?.message ||
        "Delete failed"
      );
    }

    fetchMenus();
    fetchFC();

  } catch (err) {
    notify.error(
      err?.response?.data?.message?.sqlMessage ||
      err?.response?.data?.message ||
      err?.message ||
      "Delete failed"
    );
  }
};

  useEffect(() => {
    fetchMenus();
    fetchFC();
    fetchZone();
    fetchCat();
  }, []);

  return {
    menus,
    loading,
    createMenu,
    updateMenu,
    deleteMenu,
    fetchMenus,

    // food category
    fC,
    fetchFC,

    // zone
    zone,
    cat,
  };
}